import React from 'react'
import { SingleSelect } from '@diversioteam/diversio-ds'

import { FieldWrapper } from './../FieldWrapper'
import { RatingProps } from './rating.types'
import { RATING_TYPES, RATING_WEIGHTS } from './rating.helpers'
import { RatingList } from './RatingList'
import { RatingInactive } from './RatingInactive'
import * as S from './../fields.styles'

export const Rating = ({
    item,
    isActive,
    isDeleteElementButtonDisabled,
    onAddElement,
    onChangeElementValue,
    onDeleteElement,
    onToggleRequired,
    onChangeElementType,
    onDuplicateElement,
    onChangeActiveElement,
    onChangeRatingType,
    onChangeRatingWeight,
    previewMode,
}: RatingProps) => {
    if (previewMode) {
        return <RatingInactive item={item} previewMode={previewMode} />
    }

    if (!isActive) {
        return <RatingInactive item={item} onClick={() => onChangeActiveElement(item.id)} />
    }

    return (
        <FieldWrapper
            item={item}
            isActive={isActive}
            isDeleteElementButtonDisabled={isDeleteElementButtonDisabled}
            onAddElement={onAddElement}
            onChangeElementValue={onChangeElementValue}
            onDeleteElement={onDeleteElement}
            onToggleRequired={onToggleRequired}
            onChangeElementType={onChangeElementType}
            onDuplicateElement={onDuplicateElement}
            onChangeActiveElement={onChangeActiveElement}
        >
            <S.OptionList>
                <S.OptionRow>
                    <SingleSelect
                        color="light"
                        variant="block"
                        value={item.ratingType}
                        options={RATING_TYPES}
                        onChange={(value) => onChangeRatingType(item.id, value)}
                    />

                    <SingleSelect
                        color="light"
                        variant="block"
                        value={item.ratingWeight}
                        options={RATING_WEIGHTS}
                        onChange={(value) => onChangeRatingWeight(item.id, value)}
                    />
                </S.OptionRow>

                <RatingList item={item} />
            </S.OptionList>
        </FieldWrapper>
    )
}
